@if (isOpen()) {
  <span class="b-3 text-onback-high"
    >در صورتیکه فروشگاه موردنظر این روش پرداخت را ارائه دهد، هنگام پرداخت باید شماره موبایل خود را به فروشنده بدهید تا برای شما فاکتور صادر
    کند. برای اسکن کیوآرکد روی فاکتور، باید از بارکد‌خوان دیجی‌پی در صفحه خدمات استفاده کنید.</span
  >
  <div class="my-plus d-flex justify-content-center">
    <img src="assets/qr-shopping.png" />
  </div>

  <ngx-callout
    [mode]="'multiple'"
    [title]="'نحوه خرید و پرداخت'"
    [messages]="messages"
  ></ngx-callout>
  <div class="mt-plus">
    <ngx-callout
      [mode]="'single-with-title'"
      [title]="'از فروشگاه‌های حضوری با اعتبار تک قسط و یا وام دیجی‌پی می‌توان خرید کرد.'"
      [showTitleIcon]="true"
    ></ngx-callout>
  </div>
}
